export default "__VITE_ASSET__DsMRtZ78__"